<template>
  <div class="main-content">
    <div class="section__content section__content--p30 p-b-30">
      <div class="container-fluid">
        <div class="row">
          <div class="col-xl-12 p-l-10">
            <h3 class="title-1">
              <i class="zmdi zmdi-calendar-note p-r-10" style="padding-left: 7px;"></i>
             {{ text('live_streams_header') }} ({{ totalJobs }})
            </h3>
          </div>
        </div>

        <div class="row p-b-10">
          <div class="col-md-6 p-l-10" style="min-height: 35px;">
            <v-btn
              v-show="selected.length"
              color="error"
              class="mb-0"
              @click="jobsRemoveDialog=true">
              {{ text('delete_selected_btn') }}
            </v-btn>
          </div>
          <!--div class="col-md-6 p-r-0">
            <div class="btn-group" style="width: 100%">
              <label for="search" class="p-r-10 v-align">Search:</label>
              <input type="search" id="search" class="form-control">
            </div>
          </div-->
        </div>

        <v-card class="p-b-10 p-t-10 p-l-30 p-r-30 m-b-30">
          <div class="el-loading-mask" v-if="loading">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg>
            </div>
          </div>

          <div class="row">
            <div class="table-responsive table-hover live-jobs">
              <table class="align-middle table">
                <thead>
                <tr>
                  <!--th class="checkbox" v-if="jobs.length">
                    <v-checkbox
                      hide-details
                      class="m-0 p-0"
                      v-model="allSelected"
                      @change="toggleAll">
                    </v-checkbox>
                  </th-->
                  <th>{{ text('name') }}</th>
                  <th>{{ text('profile') }}</th>
                  <th>{{ text('format') }}</th>
                  <th>{{ text('updated') }}</th>
                  <th>{{ text('status') }}</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="totalJobs === 0 && !loading">
                  <td colspan="6" class="text-center">
                    <div class="m-b-15 m-t-15">
                      {{ text('no_live_streams_text') }}
                    </div>
                  </td>
                </tr>
                <tr v-for="job of jobs" :key="job.id">
                  <!--td class="checkbox">
                    <v-checkbox
                      hide-details
                      :value="job.id"
                      :key="job.id"
                      class="m-0 p-0"
                      v-model="selected">
                    </v-checkbox>
                  </td-->
                  <td @click="showJobDetail(job)">
                    {{ job.name }}
                  </td>
                  <td @click="showJobDetail(job)">
                    {{ job.profile ? job.profile.name : 'N/A' }}
                  </td>
                  <td @click="showJobDetail(job)">
                    <span class="text-uppercase blocked-text"
                          v-for="(format, formatIndex) of getOutputFormats(job)"
                          :key="formatIndex"
                          :class="{
                          'm-r-5': getOutputFormats(job).length > 0 && formatIndex < getOutputFormats(job).length-1,
                          }">
                      {{ format }}
                    </span>
                  </td>
                  <td @click="showJobDetail(job)">
                    {{ formatCreateTime(job.update_time) }}
                  </td>
                  <td @click="showJobDetail(job)">
                    <i class="fa fa-pause job-status--paused"
                       v-if="jobState(job) === 'paused'">
                    </i>
                    <i class="fa fa-circle-notch fa-spin job-status--finished"
                       v-else-if="jobState(job) === 'processing_live'">
                    </i>
                    <i class="fa fa-exclamation status--warning"
                       v-else-if="jobState(job) === 'issues'">
                    </i>
                    <i class="fa fa-exclamation-circle job-status--failed"
                       v-else-if="jobState(job) === 'critical'">
                    </i>
                    <span class="ml-2 status p-l-5">{{ text(jobState(job)) }}</span>
                  </td>
                  <td class="text-right" style="width: 80px;">
                    <v-menu bottom left>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          v-on="on">
                          <v-icon>more_vert</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-tile @click="stopStream(job)"
                                     v-if="jobState(job) !== 'paused'" v-ripple>
                          <v-list-tile-action>
                            <v-icon>pause</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              {{ text('stop_stream_btn') }}
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile @click="startStream(job)"
                                     v-if="jobState(job) === 'paused'" v-ripple>
                          <v-list-tile-action>
                            <v-icon>play_arrow</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              {{ text('start_stream_btn') }}
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile @click="editJob(job)" v-ripple>
                          <v-list-tile-action>
                            <v-icon>edit</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              {{ text('edit_btn') }}
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile @click="openDeleteJobDialog(job)" color="red" v-ripple>
                          <v-list-tile-action>
                            <v-icon color="red">delete</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              {{ text('remove_stream_btn') }}
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--div class="text-center card-footer p-t-30" v-if="totalJobs > 0">
            <paginate
              :limit=limit
              :offset=offset
              :total=totalJobs
              :forcePage=forcePage
              @onPageChange="onPageChange">
            </paginate>
          </div-->
        </v-card>

        <!-- Remove Dialog -->
        <v-dialog v-model="jobRemoveDialog" max-width="500" persistent>
          <v-card>
            <v-card-title class="headline">
              {{ text('delete_stream_header') }}
            </v-card-title>
            <v-card-text>
              <div class="row p-b-20">
                <div class="col-md-12">
                  <v-text-field
                    v-model.trim="deleteConfirmTitle"
                    :label="text('enter_live_stream_name')"
                    :rules="[rules.required]"
                    counter>
                  </v-text-field>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                text
                @click="jobRemoveDialog = false">
                {{ text('no_btn') }}
              </v-btn>
              <v-btn
                depressed
                color="error"
                :disabled="!isTitleCheckPassed"
                @click="deleteJob">
                {{ text('yes_btn') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Jobs Remove Dialog -->
        <v-dialog v-model="jobsRemoveDialog" max-width="500" persistent>
          <v-card>
            <v-card-title class="headline">
              {{ text('delete_streams_header') }}
            </v-card-title>
            <v-card-text>
              <div class="row p-b-20">
                <div class="col-md-12">
                  {{ text('delete_streams_text') }}
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed text
                     @click="jobsRemoveDialog = false">{{ text('no_btn') }}</v-btn>
              <v-btn depressed color="error"
                     @click="deleteSelectedJobs()">{{ text('yes_btn') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import Paginate from '@/components/shared/Paginate.vue';
import { JOB_TYPES } from '@/components/transcoding/shared/types';
import { sleep } from '@/helpers/utils';

function isPaused(job) {
  return job.state === 'ready';
}

function isCriticalTask(job) {
  if (job.input.state === 'error') {
    return true;
  }
  let failed = true;
  for (let i = 0; i < job.outputs.length; i++) {
    const output = job.outputs[i];
    if (output.state !== 'error') {
      failed = false;
      break;
    }
  }
  return failed;
}

function isIssuedTask(job) {
  if (job.input.state === 'error') {
    return false;
  }
  let issued = false;
  for (let i = 0; i < job.outputs.length; i++) {
    const output = job.outputs[i];
    if (output.state === 'error') {
      issued = true;
      break;
    }
  }
  return issued;
}

export default {
  components: {
    Paginate,
  },
  created() {
    this.$store.commit('setPageLoader');
    this.loadData();
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  data() {
    return {
      limit: 100,
      offset: 0,
      forcePage: 0,
      allSelected: false,
      selected: [],
      polling: null,
      jobsRemoveDialog: false,
      jobRemoveDialog: false,
      deletedJob: {},
      deleteConfirmTitle: '',
      rules: {
        required: value => !!value || this.text('required'),
      },
    };
  },
  computed: {
    loading() {
      return this.$store.getters.isDataLoaded;
    },
    totalJobs() {
      return this.$store.getters['jobsOverview/getTotalLiveJobs'];
    },
    jobs() {
      return this.$store.getters['jobs/getLiveJobs'];
    },
    dict() {
      return this.$store.getters.dictionary;
    },
    isTitleCheckPassed() {
      return this.deleteConfirmTitle === this.deletedJob.name;
    },
  },
  methods: {
    pollData() {
      this.polling = setInterval(() => {
        this.loadData(false);
      }, 10000);
    },
    loadData(notification = true) {
      this.$store.dispatch('jobsOverview/getOverview')
        .then(() => {
          if (this.$route.query.page) {
            const offset = (this.$route.query.page - 1) * this.limit;
            if (offset > this.totalJobs || offset < 0) {
              this.offset = 0;
              this.updateRoute(1);
            } else {
              this.offset = offset;
            }
          }
          const args = {
            limit: this.limit,
            offset: this.offset,
          };
          this.$store.dispatch('jobs/getLiveJobs', args)
            .then(() => {
              if (!this.$route.query.page) {
                this.updateRoute(1);
              }
            })
            .catch((errorMsg) => {
              if (notification) {
                this.$toasted.error(errorMsg, {
                  theme: 'toasted-primary',
                  position: 'top-center',
                  duration: 10000,
                });
              }
            })
            .finally(() => this.$store.commit('resolvePageLoader'));
        })
        .catch((errorMsg) => {
          this.$store.commit('resolvePageLoader');
          if (notification) {
            this.$toasted.error(errorMsg, {
              theme: 'toasted-primary',
              position: 'top-center',
              duration: 10000,
            });
          }
        });
    },
    updateRoute(selectedPage) {
      const query = Object.assign({}, this.$route.query, { page: selectedPage });
      this.$router.push({ query });
    },
    jobState(job) {
      if (isPaused(job)) {
        return 'paused';
      }
      if (isCriticalTask(job)) {
        return 'critical';
      }
      if (isIssuedTask(job)) {
        return 'issues';
      }
      return 'processing_live';
    },
    getInputFormat(job) {
      if (!job.input.url.includes('.')) return 'N/A';
      return job.input.url.split('.').pop();
    },
    getOutputFormats(job) {
      if (job.outputs.length === 1) {
        return [JOB_TYPES[job.outputs[0].format] || 'N/A'];
      }
      const formats = [];
      if (job.outputs.length > 1) {
        for (let i = 0; i < job.outputs.length; i++) {
          const output = job.outputs[i];
          formats.push(JOB_TYPES[output.format] || 'N/A');
        }
      }
      return formats;
    },
    formatCreateTime(createTime) {
      return moment(createTime).format('DD/MM/YYYY');
    },
    toggleAll(checked) {
      if (checked) {
        const selected = [];
        for (let i = 0; i < this.jobs.length; i++) {
          selected.push(this.jobs[i].id);
        }
        this.selected = selected;
      } else {
        this.selected = [];
      }
    },
    showJobDetail(job) {
      this.$router.push({
        name: 'LiveTranscodingJobDetailPage',
        params: {
          id: job.id,
        },
      });
    },
    editJob(job) {
      this.$router.push({
        name: 'LiveTranscodingJobEditPage',
        params: {
          id: job.id,
        },
      });
    },
    startStream(job) {
      this.$store.commit('setPageLoader');
      this.$store.dispatch('jobs/startJob', job.id)
        .then(() => {
          this.loadData();
        })
        .catch((errorMsg) => {
          this.$toasted.error(errorMsg, {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 10000,
          });
        });
    },
    stopStream(job) {
      this.$store.commit('setPageLoader');
      this.$store.dispatch('jobs/stopJob', job.id)
        .then(() => {
          this.loadData();
        })
        .catch((errorMsg) => {
          this.$toasted.error(errorMsg, {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 10000,
          });
        });
    },
    openDeleteJobDialog(job) {
      this.deletedJob = Vue.util.extend({}, job);
      this.jobRemoveDialog = true;
    },
    deleteJob() {
      if (!this.deletedJob.id) return;
      this.$store.dispatch('jobs/deleteJob', this.deletedJob.id)
        .then(() => {
          this.$toasted.success(this.text('delete_stream_success_text'), {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 5000,
          });
          this.loadData();
          for (let i = 0; i < this.selected.length; i++) {
            if (this.selected[i] === this.deletedJob.id) {
              this.selected.splice(i, 1);
            }
          }
          this.deletedJob = {};
          this.jobRemoveDialog = false;
        })
        .catch((errorMsg) => {
          this.jobRemoveDialog = false;
          this.$toasted.error(errorMsg, {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 7000,
          });
        });
    },
    deleteSelectedJobs() {
      if (this.selected.length === 0) return;
      this.$store.dispatch('jobs/deleteJobs', this.selected)
        .then(() => {
          this.$toasted.success(this.text('delete_streams_success_text'), {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 5000,
          });
          this.selected = [];
          this.jobsRemoveDialog = false;
          sleep(500).then(() => {
            this.loadData(true);
          });
        })
        .catch((errorMsg) => {
          this.jobsRemoveDialog = false;
          this.$toasted.error(errorMsg, {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 7000,
          });
        });
    },
    text(code) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.dict.hasOwnProperty(code)) {
        return this.dict[code];
      }
      return code;
    },
  },
  watch: {
    $route(to, from) {
      if (from.query.page && to.query.page) {
        this.forcePage = Number(to.query.page);
      }
    },
    selected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.allSelected = false;
      } else this.allSelected = newVal.length === this.jobs.length;
    },
  },
};
</script>
